module.exports = __webpack_public_path__ + "img/planting_04@2x.ca1b7b4.jpg";